import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"

import { COLORS } from "./constants/colors"

const chipIconSx = { fontSize: 14, mr: 0.35, color: "inherit" }

const getArrowIcon = arrow => {
  switch (arrow) {
    case "up":
      return <ArrowUpwardIcon sx={chipIconSx} />
    case "down":
      return <ArrowDownwardIcon sx={chipIconSx} />
    case "forward":
      return <ArrowForwardIcon sx={chipIconSx} />
    default:
      return null
  }
}

const getPalette = accent => {
  switch (accent) {
    case "success":
      return COLORS.success
    case "warning":
      return COLORS.warning
    case "error":
      return COLORS.error
    case "default":
    default:
      return COLORS.default
  }
}

/**
 * Pastilla de métrica del resumen (Plan, desvío %, facturación «Al día», etc.).
 * Mismo aspecto en todo el Overview: bordes suaves, 14px, paleta COLORS.
 */
const OverviewMetricChip = ({
  accent,
  arrow,
  icon,
  children,
  component,
  sx,
}) => {
  const palette = getPalette(accent)
  const leading = icon ?? (arrow ? getArrowIcon(arrow) : null)

  return (
    <Box
      component={component}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 0.9,
        py: 0.2,
        borderRadius: 0.75,
        lineHeight: 1.2,
        fontWeight: 500,
        fontSize: 14,
        background: palette.background,
        color: palette.color,
        ...sx,
      }}
    >
      {leading}
      {children}
    </Box>
  )
}

OverviewMetricChip.propTypes = {
  accent: PropTypes.oneOf(["success", "warning", "error", "default"]),
  arrow: PropTypes.oneOf(["up", "down", "forward"]),
  icon: PropTypes.node,
  children: PropTypes.node,
  component: PropTypes.elementType,
  sx: PropTypes.object,
}

OverviewMetricChip.defaultProps = {
  accent: "default",
  arrow: undefined,
  icon: undefined,
  children: null,
  component: "span",
  sx: undefined,
}

export default OverviewMetricChip
